module.exports = __webpack_public_path__ + "resources/img/img_private_region_m.ba305bf4658c65fa4833b23daecc60b4.png";